module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter001"
    }
  }), _vm._v("ONE")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "line2",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("PANDORA’S BOX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("pril 21, 1770. Fifty-seven richly appointed carriages, laden with more than twice as many dignitaries and drawn by more than six times as many horses, had filled the Hofburg’s majestic central courtyard since dawn."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en1ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" But when the imperial family stepped out of the palace at nine o’clock, the crowds began to separate, making way for Maria Theresa, the stout fifty-two-year-old Empress of Austria and Queen of Hungary. Stately and imposing in her black widow’s weeds, her daily uniform ever since her husband Francis Stephen’s death five years earlier, the woman sometimes referred to as King Maria Theresa marched grandly through the courtyard."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en2ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Along with the usual cadre of courtiers and guardsmen, she was flanked by several of her ten living children, among them her eldest son and co-regent, the Holy Roman Emperor Joseph II, and her youngest daughter, fourteen-year-old Archduchess Marie Antoinette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stiff-backed imperial soldiers fired salvos from the ramparts; church bells pealed gaily throughout the city. Their voices raised above the din, court officials harangued the travelers and onlookers in German, French, Latin. "), _c('em', [_vm._v("Bella gerant alii, tu Austria felix nube")]), _vm._v(". Although Marie Antoinette had lately been studying the classics with her private tutor from France, the Abbé de Vermond, she did not need to draw on his lessons to translate this particular line. It was the Hapsburg family motto, and her mother had repeated it to her often enough in recent months: “Let other nations wage war; you, happy Austria, achieve your ends through marriage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The aphorism suited this morning’s occasion, which celebrated one of pandora’s box "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Maria Theresa’s boldest diplomatic successes to date. This scheme involved marrying off Marie Antoinette to the Dauphin Louis Auguste, the fifteen-year-old grandson of France’s King Louis XV, and the heir to the Bourbon throne. Arranged by the Austrian empress, the French king, and their respective advisers, the union was designed to cement a strategic alliance first begun by the Treaty of Paris in 1756. Before then, Austria and France had long been at loggerheads—bitter adversaries as recently as the War of the Austrian Succession (1740–1748), in which France had fought alongside Austria’s hereditary enemy, Prussia. But seven years after that conflict, Frederick II of Prussia had done an about-face by signing a treaty with France’s own longstanding foe, England. Alarming to both France and Austria, this development prompted the two countries to broker a mutually expedient defensive pact."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en3ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Franco-Austrians’ inaugural joint military effort, the Seven Years’ War (1756–1763), had proved disastrous, culminating in a resounding victory for Great Britain. Nevertheless, in its aftermath, Maria Theresa sought further to strengthen the ties between her nation and Louis XV’s. True to her family’s motto, the Empress decided to offer her youngest daughter as a bride for her Bourbon ally’s conveniently unwed heir. Louis XV’s most trusted and influential minister, the Duc de Choiseul, worked assiduously in support of the plan, and after years of delicate negotiations, the two countries agreed formally to the marriage. Now, on this spring morning, Marie Antoinette was to depart for France in triumph, a living emblem of her mother’s foreign policy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A trim strawberry blonde with wide blue eyes, rosy cheeks, and a gentle demeanor marred only by the prominent lower lip that identified her as a member of the Hapsburg clan, the bride-to-be fought back tears as she prepared to take leave of her family and her home, jostled by hundreds of Viennese well-wishers who showered her with bouquets and other mementoes."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en4ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Though visibly moved, the young archduchess made a concerted effort to smile, and navigated the crowd with grace."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en5ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Ever since her engagement the previous summer, she had been working intensively with the legendary French dancer and ballet theoretician Jean-Georges Noverre. At the court of Versailles, Noverre had reiterated in their rigorous sessions together, the ladies do not walk—they glide. Yes, their whalebone stays are painful and their shoe heels high, but they float as if their bodies are weightless. As if their feet never touch the ground."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en6ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the journey she was about to undertake, Marie Antoinette’s ladies had dressed her in the sweeping folds of a "), _c('em', [_vm._v("grand habit de cour")]), _vm._v("—the formal court dress of Versailles—cut from the most lustrous brocade that money could buy. With its lavishly beribboned, tight-fitting bodice, its voluminous hoopskirts draped over wide "), _c('em', [_vm._v("paniers")]), _vm._v(" (“baskets” fastened to the hips underneath the dress), and its long matching train hanging from stiff pleats behind her shoulders, "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("the dress presented an impressive, if highly stylized, silhouette. Because Versailles stood as a beacon of style for virtually all the courts in Europe, the look was not unfamiliar to the Archduchess: she had sported modified versions of the "), _c('em', [_vm._v("habit de cour")]), _vm._v(" at official functions throughout her childhood."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en7ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" However, like the late Emperor Francis Stephen, her brother Joseph II was opposed to excessively strict court etiquette, and upon his accession began a vigorous campaign to reduce the elaborateness of Viennese court costume."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en8ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Her assumption today of the "), _c('em', [_vm._v("grand habit")]), _vm._v(" thus represented a break with the relatively relaxed dress codes of her native milieu, and anticipated the world of unremitting formality that awaited her at Versailles.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALTHOUGH HER COMPATRIOTS IN FRANCE WOULD LATER MAKE MUCH OF HER")]), _vm._v(" penchant for undignified, “Austrian” informality, Marie Antoinette’s Viennese upbringing had afforded her some degree of training in matters of ornamentation and artifice: even as children, Hapsburgs were not exempt from ceremonial court appearances."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en9ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" When she was just ten years old, she, Maximilian, and Ferdinand (two of her brothers who were closest to her in age) had danced in a ballet for the guests at the wedding of their brother the Archduke Joseph to Josepha of Bavaria. In Martin Mytens’s lovely painting of the performance—which Marie Antoinette later had sent to her in France as a cherished memento from home—the Archduchess strikes an impressively graceful pose despite the stiffness and girth of her elaborate, hoop-skirted costume. (Plate 2.) Years before her tutelage under Noverre, she had appeared “exquisitely poised, her famous deportment already in evidence”: a credit to her illustrious birth and her mother’s high expectations."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en10ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Excelling in dance far more than in any other art form, the Empress’s youngest daughter thus gravitated at an early age toward a skill that would be crucial to her assimilation in France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another of the Archduchess’s fortuitous childhood pursuits was playing with dolls, a diversion that allowed her to practice manipulating and adorning the female form. Her interest in this pastime is captured in a 1762 portrait by her older sister, Archduchess Marie Christine, which today hangs in the Kunsthistorisches Museum in Vienna, and which depicts the imperial family gathered for an intimate breakfast on Saint Nicholas’s Day. Most of the painting’s elements suggest the invitingly relaxed domesticity that, unlike their relentlessly formal counterparts at Versailles, Maria Theresa and her clan cultivated when not participating in state occasions. Surrounded by various members of her family, all celebrating the holiday in an unstuffy, comfortable manner, seven-year-old Marie Antoinette plays excitedly with a large doll in a fancy yellow gown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("At first blush, there scarcely appears to be anything unusual about the future Dauphine’s absorption in her doll, for Saint Nicholas’s Day was then, as it is today, a gift-giving holiday that children ecstatically devote to their new toys. What "), _c('em', [_vm._v("is")]), _vm._v(" unusual about the image, and what suggests something singular about Marie Antoinette’s relationship to this particular toy, is rather the outfit she is wearing. In marked contrast to her mother and her oldest sister, Marie Christine (whose outfit in the painting Antonia Fraser has aptly described as “more like that of a maid than [that of] an Archduchess”), the little princess is wearing an ornate "), _c('em', [_vm._v("robe à la française")]), _vm._v(", a slightly less cumbersome variation on the ceremonial "), _c('em', [_vm._v("grand habit")]), _vm._v(", identifiable by its tight, low-cut bodice and by the pleated train hanging from her tiny shoulders."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en11ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" (At Versailles, the "), _c('em', [_vm._v("robe à la française")]), _vm._v(" was worn on all but the greatest state occasions.) Nothing in the surrounding scene explains or justifies the young Archduchess’s hyperelegant costume—nothing, that is, except the presence of her doll, whose sumptuous attire she seems to be copying with her own."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en12ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Whether an actual historical fact or an imaginative embellishment on the part of the artist, this odd detail is a suggestive one, for it links Marie Antoinette’s affinity for dolls—an affinity she would maintain throughout her girlhood—to what one observer described as her developing “ardor for new ensembles.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en13ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus attuned to the joys of playing dress-up, Marie Antoinette was eminently well suited for one of the key activities in which her mother enlisted her a few years later to prepare her for Versailles—shopping for the bridal trousseau. This required the thirteen-year-old archduchess to spend countless hours with dressmakers and milliners summoned from Paris to provide her with a suitably luxurious wardrobe. To showcase their wares, the fashion purveyors often relied on jointed wooden or plaster "), _c('em', [_vm._v("poupées de mode")]), _vm._v(", or “fashion dolls”—precursors to both the store mannequin and the runway model—outfitted in doll-sized versions of the latest Parisian styles."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en14ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Commonly known as Pandoras (“little Pandora” modeled morning and informal garb, while “big Pandora” was draped in ceremonial and evening wear), these dolls were crucial in disseminating the latest trends coming out of the city that was already recognized as the standard-bearer for international style."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en15ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" According to the historian Daniel Roche, “in times of war, the "), _c('em', [_vm._v("poupées")]), _vm._v(" enjoyed diplomatic immunity, and were even given cavalry escorts to ensure their safe arrival.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en16ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the biographer Carrolly Erickson has noted, “scores of these dolls began arriving at the Hofburg as soon as [the Archduchess] turned thirteen, wearing miniature versions of the robes and gowns proposed for her”; and these included")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("ball gowns, afternoon dresses, robes and petticoats in a score of delicate shades, the silks embroidered with floral designs or silk ribbon appliqué, the borders trimmed with serpentine garlands of silver and gold lace, . . . already over-decorated fabrics [trimmed] with fields of artificial flowers, feathers, tassels and silk ribbon bows, rosettes and ruffles, "), _c('em', [_vm._v("passementerie")]), _vm._v(" and beading and costly metallic fringe."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en17ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Even for a future queen, the trousseau Marie Antoinette accumulated was a spectacular one. In being fitted for these sumptuous gowns, Pierre Saint-Amand has observed, the young archduchess herself became something of “a miniature mannequin, . . . carefully prepared for the enjoyment of the French court.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en18ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Indeed, much like a "), _c('em', [_vm._v("poupée de mode")]), _vm._v(", she was to serve as a valued object of exchange between two nations, transcending diplomatic grudges and fostering mutual cooperation and goodwill. But her adoption of the dolls’ lavish apparel had other implications as well. Marie Antoinette’s transformation into a living, breathing fashion doll both allowed her to participate actively in the magic of sartorial transformations, and subjected her in the most literal sense possible to her future compatriots’ exacting standards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, her fittings with Parisian fashion purveyors were predicated on the notion that at the famously refined and discriminating court of Versailles, clothing was the currency of social acceptance and political survival. In fact, it was none other than the Duc de Choiseul, France’s strongest advocate of the Hapsburg-Bourbon union, who had stipulated the Archduchess’s wardrobe overhaul as a necessary precondition for the match. Louis XV himself had made it known that he could not possibly extend an offer of marriage on his grandson’s behalf without first knowing that Marie Antoinette was attractive enough to be a credit to his court—and Choiseul had good reasons for wishing to oblige his master on this point. As Choiseul (like the rest of the monarch’s subjects) was well aware, the King was a notorious womanizer, who had neglected his late consort, Maria Leczinska, in favor of a series of flashy mistresses."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en19ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Although the King’s heir and Marie Antoinette’s future husband, Louis Auguste, evinced nothing but frightened malaise around the opposite sex, Choiseul apparently hoped that providing the boy with a pretty, glamorous bride would, as Pierre Saint-Amand has put it, “stabilize the Bourbon monarchy and put an end to its reputation for adultery.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en20ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" However, when Choiseul first asked his chief contacts in Vienna—Marie Antoinette’s tutor, the Abbé de Vermond, and France’s ambassador, the Marquis de Durfort—about the girl’s physical appearance, both men complained of its many deficiencies. These, Maria Theresa and her emissaries were "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("informed, would have to be remedied if the Austrians wished to secure their alliance with France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Empress took the directive seriously, sparing no expense to make her daughter a visibly worthy Bourbon bride. At a time when the wardrobe of an entire working-class French family had an average value of thirty livres, and when the collective wardrobe of a wealthy aristocratic couple was worth somewhere between two thousand and five thousand livres, Maria Theresa spent a staggering four hundred thousand livres on her youngest daughter’s trousseau."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en21ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" (According to Jean Sgard’s useful if highly approximate metric, a livre in Marie Antoinette’s day was probably worth between twenty and thirty U.S. dollars today."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en22ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(") This amount far exceeded the sums the Empress had disbursed for all her other daughters’ trousseaus combined. Just as important, every garment purchased was French-made. Only in clothes that boasted such a provenance could Marie Antoinette hope to pass muster with the French king and his courtiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Choiseul and his emissaries also suggested alterations to the Archduchess’s physical person. During the marriage negotiations, they noted that the girl’s teeth were lamentably crooked. Straightaway, a French dentist was summoned to undertake the necessary oral surgeries. Although the interventions were excruciating, performed without anesthesia and requiring three long months to complete, the Archduchess was rewarded with a smile that was “very beautiful and straight.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en23ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Choiseul’s contingent also decreed that something had to be done about the princess’s hair. Marie Antoinette’s unruly mess of reddish-blond curls was habitually worn pulled back off her forehead with a harsh woolen band that ripped at her scalp. The band, however, was beginning to cause unsightly bald patches along the Archduchess’s hairline; what was more, because it created a towering “mountain of curls” atop the girl’s head, the style accentuated what French officials viewed as an unacceptably high forehead."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en24ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" To address these alarming problems, Choiseul’s stylish sister, the Duchesse de Grammont, came to the rescue by dispatching Larsenneur, who had served as hairdresser to Louis XV’s own queen, to Vienna to coif the Archduchess "), _c('em', [_vm._v("à la française."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en25ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" Re-creating the coiffure made famous by Louis XV’s beloved late mistress, Madame de Pompadour, Larsenneur tamed the Archduchess’s locks into a low, powdered upsweep studded with decorative gems. The resulting look softened her prominent forehead, saved her from further balding, and brought her directly into line with the tonsorial conventions of Versailles. What was more, the change made a strong impression on the ladies of Vienna who, like their counterparts throughout Europe, looked to France’s courtiers as paragons of style: before long, these women were “said to be abandoning their curls in favor of a style "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("[called] à "), _c('em', [_vm._v("la Dauphine")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en26ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Already at age thirteen, Marie Antoinette had become a closely observed and avidly copied trendsetter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Louis XV’s representatives also arranged for a French portraitist named Joseph Ducreux to travel to Vienna to do his part for the alliance. This painter was charged with documenting the effects of the Archduchess’s extensive makeover; for Louis XV had declared that he would not definitively agree to the union until he saw what the bride-to-be actually looked like. Before Ducreux’s arrival in January 1769, Maria Theresa had repeatedly stalled for time, putting off the Bourbon monarch’s requests “as if no artist could really capture the beauty of her daughter.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en27ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" After Marie Antoinette underwent her metamorphosis, the Empress grew more compliant and eagerly sent Louis XV Ducreux’s first completed painting in April.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, the original canvas has been lost, but during the spring of 1769, Ducreux painted two more portraits in rapid succession, both of which were sent to Versailles and widely copied by French artists and engravers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en28ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" (Plate 3.) The replicas that survive depict a fetching young dauphine with an impeccably French hairstyle and outfit that apparently dispelled the King’s doubts about her suitability once and for all—for he formally approved the match shortly after Ducreux’s first portrait reached his court. The make-over had done the trick. Now, it would simply be up to Marie Antoinette to maintain the image in which her elders had so painstakingly refashioned her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AS SHE STEPPED OUT OF THE HOFBURG TO BEGIN THE JOURNEY TO HER NEW")]), _vm._v(" homeland, the Archduchess’s appearance did not, it seems, offer much obvious room for improvement. With her "), _c('em', [_vm._v("pompadour")]), _vm._v(" coif, her cosmetically enhanced smile, and her elaborate brocaded gown, she reportedly looked the very picture of the flawless French princess. And as she effortlessly maneuvered her outsized hoopskirts and train, she carried herself like one as well. Even her staunchest detractors at Versailles would later concede that Marie Antoinette knew how to glide with the best of them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en29ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of a sudden, her light floating movements gave way to actual, if momentary, flight, as her handsome brother Ferdinand swept her up into the capacious "), _c('em', [_vm._v("berline")]), _vm._v(" that Louis XV had sent to fetch her. Designed by the Parisian carriagemaker Francien with detailed input from the Duc de Choiseul, the "), _c('em', [_vm._v("berline")]), _vm._v(" looked for all the world like a giant jewel box."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en30ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Its front, side, and rear panels fashioned almost entirely of glass, and its ornate, garlanded trimwork wrought from white, rose, and yellow gold, drew whistles of admiration from the crowd. On its solid gold slab of a roof, “bouquets of flowers of gold in different colors waved gracefully in the slightest breeze.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en31ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Magnificent "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("golden harnesses tethered a team of eight white horses to the carriage; the tall feathers in their manes bobbed in time as they snorted and pawed at the ground."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en32ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside the "), _c('em', [_vm._v("berline")]), _vm._v(", plush crimson upholstery depicted the Four Seasons, painstakingly embroidered in golden thread by a master craftsman named Trumeau."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en33ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Of Spring, Marie Antoinette had already heard plenty of late. Over the previous week, she had been guest of honor at a seemingly unending series of state dinners and fêtes celebrating new beginnings, unspoiled youth, fruitful days to come. Yet amid all the merry-making, no one had thought to prepare the girl for the challenges her future held in store. She had simply been told that she had won the most glittering prize that anyone, even a Hapsburg archduchess, could possibly hope to obtain."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en34ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside the "), _c('em', [_vm._v("berline")]), _vm._v(" stood the Archduchess’s family, the palace where she had spent her girlhood, the friends and servants she had known her entire life. With very few exceptions, she would never see any of them again."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en35ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Through a wall of glass she stared out at the unsmiling Empress, who had recently consulted a psychic as to her daughter’s prospects for success at Versailles, only to be told: “Every pair of shoulders has its cross to bear.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en36ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" With a last, pleading look at her mother, the young woman began to cry."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en37ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trumpeters sounded their horns, and the Swiss Guards fired their guns in a deafening salute. Escorted by blue-and-gold-liveried outriders who would accompany it as far as the city gates, the Archduchess’s carriage joined the vast, jostling cortège and rolled slowly out of the courtyard. In its wake, her childhood playmate Joseph Weber remembered, “the avenues and streets of Vienna resounded with expressions of sorrow.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en38ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Perhaps in an attempt to hide her emotion from the Princesse de Paar—a longtime friend of her mother’s, and her only companion in the oversized "), _c('em', [_vm._v("berline")]), _vm._v("—Marie Antoinette busied herself with the little pug dog, Mops, that lay curled up in her lap."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en39"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en39ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Still, spectators observing her passage noted with alarm that “her cheeks were bathed in tears.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en40"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en40ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" According to Joseph Weber, her weeping became especially evident when the young girl poked her head outside the carriage window, craning her neck and staring back toward the Hofburg, until the Empress’s black-clad figure at last disappeared from view.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Maria Theresa remained with her in spirit. As a parting gift, Marie Antoinette had received from her mother a tiny gold watch, which was to remain one of her most prized possessions, even when her jewel collection expanded to include far more extravagant pieces. Just as important, when the "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("cortège stopped at Freiburg days later, the Archduchess received a letter her mother had apparently penned as soon as her "), _c('em', [_vm._v("berline")]), _vm._v(" left the Hofburg. Entitled “Regulation to Read Every Month,” the missive provided detailed, unstinting advice about how Marie Antoinette should conduct herself at Versailles. “You must not do anything unusual,” the letter commanded. “On the contrary, you must absolutely lend yourself to what the court is accustomed to doing.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en41"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en41ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, several lines later, the intimidating warning: “All eyes will be fixed on you.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en42"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en42ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONCE SHE BECAME DAUPHINE, ALL EYES WOULD INDEED BE FIXED ON")]), _vm._v(" Marie Antoinette as a figure at the very center of court ritual. In the spectacular ceremonies of Versailles, regulations governing when, how, and in whose company she dressed would serve as constant reminders that her body not only belonged to the crown but existed as visible proof of its splendor. Especially since the long reign (1643–1715) of Louis XIV, opulent personal adornment had functioned to underscore the Bourbons’ absolute power. As subsequent historians have argued, even such seeming trivialities as “hair, embroidery, ribbons,” precious metals, gemstones, and lace—those indispensable features of the French royal costume—were instantly recognizable to the Bourbons’ subjects as “effects of force.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en43"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en43ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Wordlessly but eloquently, this ornamentation impressed upon all viewers their king’s ability to channel limitless resources into his own, and his family’s, supreme glorification. As the wife of the future French monarch, Marie Antoinette would have to embody this principle in every last detail of her appearance, and to present herself for the approval of countless tenacious stares."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en44"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en44ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet even the most meticulously cultivated appearance could not guarantee that approval would be hers. Many French people blamed Austria for the failure of the Seven Years’ War, in which France had been forced to cede her Canadian and Indian colonies to England."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en45"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en45ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" In fact, a goodly number of courtiers at Versailles had since begun lobbying in earnest for a return to the kingdom’s previous, uncompromising distrust of Maria Theresa and her compatriots. That the new policy had been the work of the Duc de Choiseul, whose vast political influence and controversial positions on philosophy and religion had earned him countless enemies at court, made these individuals even more determined to overturn the Austrian alliance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although loosely assembled under the catch-all name of “the French party,” the anti-Austrian faction at court belonged to two otherwise distinct "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("social cliques. The first of these was the cabal of aristocrats supporting the King’s latest titular mistress, Madame Du Barry. Choiseul had benefited richly from the patronage of Du Barry’s predecessor, Madame de Pompadour, and after she died, those who loathed him had cast about for a royal mistress who would further their own interests at his expense. Led by the conniving Duc d’Aiguillon and the Duc de La Vauguyon, tutor to the young Dauphin, this group attempted to trounce the great minister by installing Madame Du Barry—a bewitching former prostitute with a taste for luxury items and few political ideas of her own—in Louis XV’s bed. On a personal level, there was no love lost between the new “favorite” (as the King’s maîtresses en titre or maîtresses déclarées were commonly known) and Choiseul, whose sister, the Duchesse de Grammont, despised Du Barry for her lowly birth and promiscuous background."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en46"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en46ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet Choiseul’s foes recognized quite rightly that with the advent at court of another beautiful young woman, Madame Du Barry might not retain her monopoly on the notoriously fickle sovereign’s good graces. (In fact, in the initial stages of his marriage negotiations with Maria Theresa, Louis XV had considered putting himself forward as the bridegroom, before concluding that his grandson represented the more sensible candidate.) Marie Antoinette thus posed a threat to Madame Du Barry herself, and to the group whose social advancement at court went hand in glove with the favorite’s unrivaled standing there."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en47"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en47ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other important wing of the French party—more commonly known as the devout party, because of its members’ staunch religious convictions—was headed up by Louis XV’s three spinster daughters, Adélaïde, Victoire, and Sophie. Known collectively as “Mesdames” (the conventional name for royal female offspring) or “the Aunts” (because of their relationship to the heir to the throne), these pious, unattractive, and unhappy women despised Du Barry but, like her, had scores to settle with Choiseul."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en48"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en48ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" These ranged from his friendship with the late Madame de Pompadour, whom they had bitterly envied, to his successful persecution of France’s Jesuit priests, whom they had avidly supported."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en49"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en49ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" These factors trumped even Mesdames’ abiding hatred for the lowborn, simpering strumpet whose wiles held their father enthralled."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en50"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en50ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Mesdames as for the "), _c('em', [_vm._v("barrystes")]), _vm._v(", then, Choiseul’s stance on Austria presented yet another urgent reason to plot his demise. More to the point, the bride he had imported for the Dauphin became a target for all manner of strategic backstabbing and intrigue. Should she fail to produce an heir or perform in an exemplary manner, perhaps Marie Antoinette could be sent back home to Vienna. Should this occur, Choiseul’s foreign policy "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("(and his reputation) would be in tatters. This was the anti-Austrians’ secret hope."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en51"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en51ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fourteen-year-old archduchess’s future was also complicated by the fact that France was a terminally ailing kingdom. The nation’s coffers were woefully underfunded and many of its people underfed. Its ruler—once referred to as “Louis the Well Beloved”—had in recent times lost his nickname along with his subjects’ respect."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en52"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en52ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Badly damaged by the Seven Years’ War, the King’s reputation had also deteriorated because of his autocratic and bullying style of government, as well as the unpopular tax reforms he had imposed on his subjects by means of special sessions called "), _c('em', [_vm._v("lits de justice")]), _vm._v(". In these sessions, the King personally overrode objections leveled against his proposals by the "), _c('em', [_vm._v("parlements")]), _vm._v(", the judiciary bodies charged, in principle, with the task of registering royal edicts. “Le roi le veult” (“the King wishes it”): at a "), _c('em', [_vm._v("lit de justice")]), _vm._v(", this was the only justification offered for riding roughshod over dissenting parlementaires."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en53"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en53ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reported among the flourishing Enlightenment circles of Paris, where progressive-minded intellectuals advanced new ideas about mankind’s fundamental equality and heatedly debated the very legitimacy of monarchical rule, Louis XV’s recourse to the "), _c('em', [_vm._v("lit de justice")]), _vm._v(" became a prime example of absolutism run amok. But the King seemed quite happy to conduct his political affairs in the spirit of Pompadour’s infamous battle-cry, "), _c('em', [_vm._v("“Après nous, le déluge”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en54"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en54ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" (“After us, the deluge”). As this dictum implied, the serious problems that had developed during Louis XV’s rule gave him little cause for concern, for they would one day be someone else’s to deal with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then there was the issue, already considered by Choiseul, of the King’s extramarital shenanigans with Pompadour and Du Barry, who inspired loathing both within and beyond the court for the power they wielded, for the riches the King lavished upon them, for their complicity in his moral decline, and for the sheer, unjust arbitrariness of their exalted placement. For a long time and to a large extent, the French people succeeded in displacing onto these royal favorites many of their principal grievances against the monarch himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Louis XV, though, further alienated his subjects by indulging in sheer venal libertinism to boot. In addition to his official paramours, the ruler’s conquests included countless young women culled from the so-called vile classes, many of whom he maintained in private brothels not far from Versailles. Established in an area called the Parc aux Cerfs (that is, the Deer Park, where Louis XIII had hunted more acceptable game), these brothels offered proof of the “Well-Hated” ’s irreversible slide into immorality. It mattered little when Madame Du Barry, anxious to keep a closer watch on her "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("lover, prevailed upon him to close the brothels down; as far as many of his subjects were concerned, the damage to the King’s reputation had long since been done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SO IT WAS THAT WHEN MARIE ANTOINETTE SET A TINY SILK SLIPPER ONTO THE")]), _vm._v(" stage of French public life in 1770, she was, without knowing it, facing a restless and bifurcated audience. On the one hand, a court fraught with rivalry and vendettas viewed her as a handy pawn in its high-stakes struggles for power. On the other hand, a nation on the verge of revolt expected her to breathe new life into its decaying monarchy. Although different in many respects, these groups shared one implicit conviction: that the way the Dauphine looked was crucial to her prescribed role. One of the prints produced in the period leading up to Marie Antoinette’s marriage, a portrait of the bride dressed in a handsome "), _c('em', [_vm._v("robe à la française")]), _vm._v(", expressed this view neatly in its caption:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_vm._v("With her beauty winning our hearts"), _c('br'), _vm._v("And virtue decorating her,"), _c('br'), _vm._v("Already France adores her;"), _c('br'), _vm._v("She will establish happiness here."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en55"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en55ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maria Theresa could not have put it better herself. She had not spent 400,000 livres on her daughter’s trousseau for nothing, understanding as she did that in France in general, and at Versailles in particular, one should never underestimate the power of the Bourbon strictures equating princely beauty with virtue, surface appearance with underlying essence."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en56"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en56ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Maintaining these equations would be one of Marie Antoinette’s most important, and least negotiable, duties as Dauphine. Her success or failure in “establishing the happiness” of her subjects would depend at least in part on her continued willingness to dress for success.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DRIVING AWAY FROM VIENNA THROUGH HER MOTHER’S TERRITORIES, THE")]), _vm._v(" fourteen-year-old archduchess certainly looked to be on her best behavior. Arrayed in her lavish French finery, she gave herself over to innocent pursuits inside the glass "), _c('em', [_vm._v("berline")]), _vm._v(". She stared out the windows at the passing scenery. She hid her tears, smiling and waving on cue for the droves of people who had lined the roads to cheer her on. She chatted brightly with the Princesse de Paar, upon whom the Dauphine would later bestow, as a reward for her companionship on this journey, a dress bodice embroidered with more than twelve hundred diamonds of different sizes."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en57"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en57ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" And, hugging her little dog "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("tightly for comfort, she reread her mother’s letter. In keeping with the advice it set forth, the girl was not doing anything out of the ordinary . . . so far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But unusual times breed unusual measures, and when, after two and a half weeks of traveling, she reached the border between France and Austria, she would confront the first of many singular circumstances marking her reign as French fashion’s brightest star and its unhappiest victim. Meanwhile, back in Vienna, an anxious Maria Theresa was spending much more time than usual in prayer, imploring “the Almighty to avert a disaster that she alone had foreseen.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en58"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en58ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Time and again, this disaster would play itself out on the surface of her daughter’s well-dressed body. As a political cartoon would charge years later, in sending Marie Antoinette to France, the Empress had blown the lid off Pandora’s box."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01en59"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002#en59ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f596f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 87
// module chunks = 0